/*
 * @Author: lvjinbin
 * @Date: 2022-10-05 17:34:55
 * @LastEditors: lvjinbin-at-631455864747 1367100043@qq.com
 * @LastEditTime: 2022-11-23 15:43:50
 * @FilePath: \sharkfoto_new\utils\storage.js
 * @Description: 基于localStroge的简单封装
 */

// const typeMap = new Map([
//   ['Number', 0],
//   ['String', ''],
//   ['Array', []],
//   ['Object', {}],
//   ['Function', null]
// ])

export const getItem = (key, type) => {
  if (process.browser) {
    try {
      const value = localStorage.getItem(key)
      return value !== null ? JSON.parse(value) : value
    } catch {
      return null
    }
  }
}

export const setItem = (key, value) => {
  if (process.browser) {
    localStorage.setItem(key, JSON.stringify(value))
  }
}

export const clearStorage = () => {
  if (process.browser) { 
    localStorage.clear()
  }
}

export const removeItem = (key) => {
  if (process.browser) {
    localStorage.removeItem(key)
  }
}
